export default {"src":"/_next/static/media/Icon_WhatsApp.4f694f89.svg","height":40,"width":40};